import Http from '@/services/http';
import translate, { formatNumber } from '@/services/translate';
import { RegistrationDataResponse, RegistrationData } from 'sigma-mappings';
import registrationDataFields from '@/domain/data/installation/assetInformation/registrationDataFields';

const urls = {
  registrationData: id => `ativo/${id}/dados-cadastrais`,
};

/* istanbul ignore next */
const error = {
  errorHandling: {
    responseMessageParams: {
      $MA010: (data) => {
        const actualField = registrationDataFields[data.parameters[0]];
        return {
          NomeDoCampo: translate(actualField.label),
          NroCaracteres: formatNumber(data.parameters[1]),
        };
      },
      $MA035: data => data,
      $MA048: data => ({
        0: data.value,
      }),
      $MA051: (data) => {
        const returnedField = registrationDataFields[data.parameters[1]];
        return {
          maxLength: data.parameters[0],
          fieldName: translate(returnedField.label),
        };
      },
    },
  },
};

export default {
  getRegistrationAssetData(assetId) {
    /**
    *  Obtém os dados da aba Dados Cadastrais do Ativo
    *  @param {guid} assetId ID do ativo que será atualizado
    */
    const http = new Http();
    return http
      .get(urls.registrationData(assetId))
      .then(({ data }) => new RegistrationDataResponse(data));
  },

  /**
  *  Atualiza os dados cadastrais do ativo
  */
  updateRegistrationAssetData(payload, assetId) {
    const mappedPayload = new RegistrationData.MapBack(payload);
    const http = new Http(error);
    return http
      .put(urls.registrationData(assetId), mappedPayload)
      .then(({ data }) => data);
  },
};
